






























































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'
import { Channel, PaymentType } from '@/api/model/channel'
import $Api from '@api'

@Component
export default class ThreePartDialog extends Vue {
        @Prop()
        show = false

        dialogVisible = false
        dialogWidth = 919
        inputWidth = 180

        @Watch('show')
        onShowChanged(newVal: boolean) {
            this.dialogVisible = newVal
        }

        @Emit()
        onUpdate() {
        }

        @Emit('update:show')
        onClose() {
            ;(this.$refs['data'] as any).resetFields()
            this.data.list.length = 1
            return false
        }

        data: any = {
            list: [{
                channelId: '',
                paymentType: '',
                key: '',
                value: ''
            }]
        }
        channels: Channel[]= []
        paymentTypeList: PaymentType[] = []

        submit(data: string) {
            (this.$refs[data] as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.requestAddApi()
                } else {
                    return false
                }
            })
        }

        requestAddApi() {
            $Api.channelService.addAbroadThirdParameterBatch(this.data.list).subscribe(data => {
                this.$emit('update:show', false)
                this.$emit('onUpdate')
                this.$message.success('Success!')
            })
        }

        async loadData() {
            $Api.channelService.queryChannelDropdown().subscribe(data => {
                this.channels = data
            })
            $Api.channelService.queryPaymentTypeList().subscribe(data => {
                this.paymentTypeList = data
            })
        }

        addForm() {
            this.data.list.push({
                channelId: '',
                paymentType: '',
                key: '',
                value: ''
            })
        }

        deleteForm(index: number) {
            this.data.list.splice(index, 1)
        }

        copyForm(index: number) {
            const currentItem = Object.assign({}, this.data.list[index])
            this.data.list.push(currentItem)
        }
}
